var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ui-drilldown"},_vm._l((_vm.options),function(option){return _c('div',{key:option.name,staticClass:"descendant-lines"},[_c(_setup.FormDrilldownOption,{attrs:{"current-value":_vm.currentValue,"handle-click":_vm.handleClick,"multiple":_vm.multiple,"option":option}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }